import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - Intron Life Sciences</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="flex items-center justify-center h-screen bg-primary-300">
        <div className="text-center text-white">
          <h1 className="text-[60px] font-bold">404</h1>
          <p className="text-[17px] mt-4">Oops, Page Not Found</p>
          <Link
            to="/"
            className="mt-6 inline-block px-6 py-2 text-primary bg-white font-semibold rounded-lg shadow-md hover:bg-gray-200"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
